module.exports = __webpack_public_path__ + "static/logo-bueno-209cbb2bb0e991a231b74ce71c6286f0.png";